<!-- 激活邮箱 -->
<template>
  <el-dialog v-model="state.visible" :title="$t('form.emailVerification')" width="580px" class="dialog-wrapper">
    <div class="dialog-inner">
      <img class="img" src="@/assets/images/common/email-verify.png" />
      <p class="text">{{ $t('form.verifyMsg') }}</p>
      <el-button class="dialog-dtn" type="primary" @click="sendEmail">{{
        $t('form.sendVerificationEmail')
        }}</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { activeVerifyEmail } from '@/apis/user';
import { useUserStore } from '@/stores';
import { ElMessage } from 'element-plus';
import { defineExpose, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const userStore = useUserStore();

const state = reactive({
  visible: false,
  loading: false
});
const sendEmail = async () => {
  if (state.loading) return;
  state.loading = true;
  try {
    await activeVerifyEmail({ account: userStore.profile.email });
    userStore.getUserInfo();
    ElMessage({ type: 'success', message: t('form.hasSendEmail') });
    state.visible = false;
  } catch (error) {
    //
  } finally {
    state.loading = false;
  }
};

const openModal = () => {
  state.visible = true;
};

defineExpose({
  openModal
});
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  .dialog-inner {
    padding: 0 24px;
    text-align: center;

    .img {
      width: 157px;
      height: 157px;
      margin: auto;
    }

    .text {
      margin-top: 20px;
      font-size: 14px;
      color: var(--black-color-9);
    }

    .dialog-dtn {
      height: 44px;
      border-radius: 8px;
      padding: 0 20px;
      margin-top: 30px;
      margin-bottom: 24px;
    }
  }
}
</style>
